import { Component, Input, TemplateRef } from '@angular/core';


/**
 * Child view for the StateViewChild component (<empty-state>, <loading-state>, <content-state>, and <error-state> are
 * all instances of this component). The content for the child view may either be passed directly via the content of
 * the tag, or alternatively a reference to a template may be passed instead via the "template" property.
 */
@Component({
  selector: 'empty-state, loading-state, content-state, error-state' + '',
  templateUrl: './state-view-child.component.html',
})
export class StateViewChildComponent {
  /**
   * Optional template reference to be used for the child view content. If a template is passed in via this property,
   * it will take precedence over the content passed via this component directly.
   */
  @Input() template: TemplateRef<any>;

  /**
   * Optional template context for the template reference passed via the "template" property.
   */
  @Input() templateContext: any;
}
